import { render, staticRenderFns } from "./DashboardClientInformation.vue?vue&type=template&id=584b1ca6&"
import script from "./DashboardClientInformation.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584b1ca6')) {
      api.createRecord('584b1ca6', component.options)
    } else {
      api.reload('584b1ca6', component.options)
    }
    module.hot.accept("./DashboardClientInformation.vue?vue&type=template&id=584b1ca6&", function () {
      api.rerender('584b1ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientInformation.vue"
export default component.exports